import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "hubspot--form" }

import { ref, onMounted, onUnmounted, reactive, watch, onBeforeUnmount } from 'vue'
  import { useElementBounding} from '@vueuse/core'
  import _ from 'lodash';
  import { FormInfo, useFormStore } from '../../store/forms'
  import { loadScript } from  '../../tools/index'

  //import { gsap } from 'gsap';
  //import { ScrollTrigger } from 'gsap/ScrollTrigger';

  enum themes {
    IA = 'theme-ia',
    DARK_HEALTCARE = 'theme-dark-healtcare'
  }

  interface Props {
    portalId: String,
    formId: String,
    title?: String,
    disclaimer?: String,
    isFixedAfterView?: Boolean,
    theme?: themes
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'hubspot-form',
  props: {
    portalId: {},
    formId: {},
    title: {},
    disclaimer: {},
    isFixedAfterView: {},
    theme: {}
  },
  setup(__props: any) {

  const props = __props
  const store = useFormStore()
  const inicialRef = ref(null)
  const component = ref(null)
  const componentWrapper = ref(null)
  const componentBody = ref(null)
 
  const inicialRect = reactive(useElementBounding(inicialRef))
  const componentRect = reactive(useElementBounding(component))
  const bodyRect = reactive(useElementBounding(componentBody))
  let containerRect = ref(null)
  
  const isFixed = ref(false)

  // Registrar el plugin de ScrollTrigger
  //gsap.registerPlugin(ScrollTrigger);

  const loadHubspotForm = ({ portalId, formId}: Props) => {
    loadScript('https://js.hsforms.net/forms/embed/v2.js', () => {
      window.hbspt.forms.create({
            target: '.hubspot--form-container',
            region: 'na1',
            portalId: portalId,
            formId: formId,
            css: ''
        })
    })
  }

  const handleScroll = ( event ) => {
    const container = component.value?.closest('#form-container');
    const bodyRectHeight = bodyRect.height + 130;

    if ( inicialRect.top < 80 && !isFixed.value ) {
      isFixed.value = true;
      componentWrapper.value.style.maxHeight = 'calc(100vh - 100px)';
      setTimeout(() => {
        component.value.scrollTop = 0;
      }, 100);
    }

    if ( inicialRect.top >= 80 && isFixed.value ) {
      isFixed.value = false
    }

    if ( bodyRectHeight > containerRect.bottom ) {
      isFixed.value = false;
      container.classList.add('flex-end');
      componentWrapper.value.style.maxHeight = 'none';
    } else {
      container.classList.remove('flex-end');
    }


  }

  function scrollAnimation() {
    if ( window.innerWidth >= 992) {
      const allTriggers = ScrollTrigger.getAll();
      allTriggers.forEach(trigger => trigger.kill(true));

      const container = component.value?.closest('#form-container');
      const parent = component.value;
      console.log('parent', parent);
      console.log('container height', container.offsetHeight);

      if (parent) {
        gsap.fromTo(
          parent,
          { opacity: 1 },
          {
            opacity: 1,
            scrollTrigger: {
              trigger: parent,
              anticipatePin: true,
              pin: true,
              toggleClass: 'pin-active',
              start: "clamp(-50px top)",
              end: `+=${ container.offsetHeight / 2  }`,
              scrub: true,
              markers: true,
            },
          }
        );
      }
    } else {
      const allTriggers = ScrollTrigger.getAll();
      allTriggers.forEach(trigger => trigger.kill(true));
    }
  }

  onMounted( ()  => {

    loadHubspotForm(props)

    window?.addEventListener('message',  ( event ) => {
      if(event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmitted') {
        const submitedData = event.data?.data?.submissionValues || null
        const formData: FormInfo = {
          formId: event.data?.id,
          submitedEmail: submitedData?.email || ''
        }
        store.setSubmited(formData)
        store.$patch({
          submitedForm: formData
        })
      }
    })

    if ( props.isFixedAfterView ) {
      containerRect = reactive(useElementBounding(component.value?.closest('#form-container')))
      window?.addEventListener('scroll', _.throttle(handleScroll, 200))

      //scrollAnimation();
      //window?.addEventListener('resize', _.throttle(scrollAnimation, 200))
    }
  })

  onBeforeUnmount( () => {
    if ( props.isFixedAfterView ) {
      window.removeEventListener('scroll', handleScroll);
      //window.removeEventListener('resize', scrollAnimation);
      //ScrollTrigger.getAll().forEach(trigger => trigger.kill(true));
    }
  })

  onUnmounted( () => {

  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      ref_key: "inicialRef",
      ref: inicialRef
    }, null, 512),
    _createElementVNode("div", {
      ref_key: "component",
      ref: component,
      class: _normalizeClass(["hubspot--component", {
      'fixed-md': isFixed.value
    }])
    }, [
      _createElementVNode("div", {
        ref_key: "componentWrapper",
        ref: componentWrapper,
        class: "hubspot--component-wrapper"
      }, [
        _createElementVNode("div", {
          ref_key: "componentBody",
          ref: componentBody,
          class: "hubspot--component-body"
        }, [
          (_ctx.title)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["hubspot--title", `hubspot--title ${ _ctx.theme || '' }`])
              }, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.title), 1)
              ], 2))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_1, [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "hubspot--form-container" }, null, -1)),
            (_ctx.disclaimer)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["", `hubspot--disclaimer ${ _ctx.theme || '' }`])
                }, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.disclaimer), 1)
                ], 2))
              : _createCommentVNode("", true)
          ])
        ], 512)
      ], 512)
    ], 2)
  ], 64))
}
}

})